import React, { useState } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { useQuery } from "react-query";
import Constants from "../services/Constants";
import ExportOption from "./common/ExportOption";
import { Typography } from "@mui/material";

const OTAPagination = (props) => {
  const {
    endpointFn,
    queryName,
    sortByDefault,
    columns,
    extraFilters,
    exportRowsData,
    allVehicles = false,
    fetchAll = false,
    exportCSV = false,
    tableTitle,
    defaultExport = false,
    newSx: sxFromProps,
  } = props;
  const [data, setData] = useState({
    loading: true,
    rows: [],
    totalRows: 0,
    rowCount: 0,
    pageSize: Constants.PAGE_SIZE,
    page: 1,
    field: sortByDefault,
    sort: "desc",
    filterValue: {},
  });

  const { filterValue = {}, page, pageSize, field, sort, rowCount } = data;

  //Queries
  const { data: { data: { res: paginationData = [] } = {} } = {}, isLoading } =
    useQuery(
      [
        queryName,
        page,
        pageSize,
        field,
        sort,
        filterValue,
        columns,
        extraFilters ? extraFilters : [],
        fetchAll,
        allVehicles,
      ],
      endpointFn,
      {
        onSuccess: (response) => {
          const { data: { meta = {} } = {} } = response;
          setData({
            ...data,
            rowCount: meta.itemCount,
          });
          exportRowsData?.(response?.data?.res || []);
        },
      }
    );

  const handleSortModelChange = (newModel) => {
    let sortData = newModel[0] ?? { field: sortByDefault, sort: "desc" };
    setData({ ...data, ...sortData });
  };

  const onFilterChange = (filterValue) => {
    setData({
      ...data,
      filterValue,
    });
  };

  const exportProps = [
    `${queryName}Export`,
    page,
    pageSize,
    field,
    sort,
    filterValue,
    columns,
    extraFilters ? extraFilters : [],
    true,
    allVehicles,
  ];

  function CustomToolbar() {
    // This custom toolbar is used for places where custom export is needed,
    // this export toolbar is different from the export option in the reports modules.
    return (
      <GridToolbarContainer
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "1em",
          borderBottom: "1px solid lightgray",
          height: "4.2em",
        }}
      >
        <Typography variant="h6">{tableTitle}</Typography>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {exportCSV ? (
            <ExportOption
              data={exportProps}
              endpointFn={endpointFn}
              queryName={queryName}
            />
          ) : (
            <>
              {defaultExport ? (
                <GridToolbarExport
                  printOptions={{ disableToolbarButton: true }}
                />
              ) : (
                <div />
              )}
            </>
          )}
          {/* <GridToolbarDensitySelector /> */}
        </div>
      </GridToolbarContainer>
    );
  }

  return (
    <>
      <DataGrid
        initialState={{
          sorting: {
            sortModel: [{ field: sortByDefault, sort: "desc" }],
          },
        }}
        pageSize={pageSize}
        rowsPerPageOptions={Constants.ROWS_PER_PAGE_OPT}
        pagination
        // sx={{ minHeight: 700 }}
        sx={[
          { flex: 1, minHeight: 700 }, 
          ...(Array.isArray(sxFromProps) ? sxFromProps : [sxFromProps]),
        ]}
        loading={isLoading}
        rowCount={rowCount}
        page={page - 1}
        rows={paginationData}
        onPageChange={(page) => {
          setData({
            ...data,
            page: page + 1,
          });
        }}
        onPageSizeChange={(pageSize) => {
          setData({
            ...data,
            page: 1,
            pageSize,
          });
        }}
        onSortModelChange={handleSortModelChange}
        filterValue={filterValue}
        onFilterModelChange={onFilterChange}
        {...props}
        components={{
          Toolbar: CustomToolbar,
        }}
      />
    </>
  );
};

/***
  The Following props are from the parent components and it differs

  columns
  onSelectionModelChange
  getRowId
  paginationMode
  checkboxSelection
***/

OTAPagination.defaultProps = {
  paginationMode: "server",
  sortByDefault: "createdAt",
  checkboxSelection: false,
  fetchAll: false,
  allVehicles: false,
  exportCSV: false,
  endpointFn: () => {},
  queryName: "",
};

export default OTAPagination;
